import { render } from "./CreateOrganiser.vue?vue&type=template&id=ae6b8fe2"
import script from "./CreateOrganiser.vue?vue&type=script&lang=js"
export * from "./CreateOrganiser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__